// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"65":"130876e0","82":"8ff41da2","453":"ff7866cb","463":"09f10eac","613":"60f7c38d","707":"e86c2a6a","719":"32c2715d","743":"f00c352d","953":"1e01f871","973":"a4fb9511"}[chunkId] + ".chunk.js";
};